// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: var(--uib-size);
  width: var(--uib-size);
  animation: rotate calc(var(--uib-speed) * 3) linear infinite;
}

.dot {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
}

.dot-inner {
  content: "";
  height: 20%;
  width: 20%;
  border-radius: 50%;
  background-color: var(--uib-color);
  animation: oscillate var(--uib-speed) ease-in-out infinite alternate;
  transition: background-color 0.3s ease;
}

.dot:nth-child(1) .dot-inner {
  transform: translateX(var(--uib-center));
}

.dot:nth-child(2) .dot-inner {
  transform: translateX(var(--uib-center));
  animation-delay: calc(var(--uib-speed) * -0.125);
}

.dot:nth-child(3) .dot-inner {
  transform: translateX(var(--uib-center));
  animation-delay: calc(var(--uib-speed) * -0.25);
}

.dot:nth-child(4) .dot-inner {
  transform: translateX(var(--uib-center));
  animation-delay: calc(var(--uib-speed) * -0.375);
}

.dot:nth-child(5) .dot-inner {
  transform: translateX(var(--uib-center));
  animation-delay: calc(var(--uib-speed) * -0.5);
}

.dot:nth-child(6) .dot-inner {
  transform: translateX(var(--uib-center));
  animation-delay: calc(var(--uib-speed) * -0.625);
}

.dot:nth-child(7) .dot-inner {
  transform: translateX(var(--uib-center));
  animation-delay: calc(var(--uib-speed) * -0.75);
}

.dot:nth-child(8) .dot-inner {
  transform: translateX(var(--uib-center));
  animation-delay: calc(var(--uib-speed) * -0.875);
}

@keyframes oscillate {
  0% {
    transform: translateX(var(--uib-center)) scale(0);
    opacity: 0.25;
  }

  100% {
    transform: translateX(0) scale(1);
    opacity: 1;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Loader.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,oEAAoE;EACpE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE;IACE,iDAAiD;IACjD,aAAa;EACf;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".container {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  height: var(--uib-size);\r\n  width: var(--uib-size);\r\n  animation: rotate calc(var(--uib-speed) * 3) linear infinite;\r\n}\r\n\r\n.dot {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.dot-inner {\r\n  content: \"\";\r\n  height: 20%;\r\n  width: 20%;\r\n  border-radius: 50%;\r\n  background-color: var(--uib-color);\r\n  animation: oscillate var(--uib-speed) ease-in-out infinite alternate;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.dot:nth-child(1) .dot-inner {\r\n  transform: translateX(var(--uib-center));\r\n}\r\n\r\n.dot:nth-child(2) .dot-inner {\r\n  transform: translateX(var(--uib-center));\r\n  animation-delay: calc(var(--uib-speed) * -0.125);\r\n}\r\n\r\n.dot:nth-child(3) .dot-inner {\r\n  transform: translateX(var(--uib-center));\r\n  animation-delay: calc(var(--uib-speed) * -0.25);\r\n}\r\n\r\n.dot:nth-child(4) .dot-inner {\r\n  transform: translateX(var(--uib-center));\r\n  animation-delay: calc(var(--uib-speed) * -0.375);\r\n}\r\n\r\n.dot:nth-child(5) .dot-inner {\r\n  transform: translateX(var(--uib-center));\r\n  animation-delay: calc(var(--uib-speed) * -0.5);\r\n}\r\n\r\n.dot:nth-child(6) .dot-inner {\r\n  transform: translateX(var(--uib-center));\r\n  animation-delay: calc(var(--uib-speed) * -0.625);\r\n}\r\n\r\n.dot:nth-child(7) .dot-inner {\r\n  transform: translateX(var(--uib-center));\r\n  animation-delay: calc(var(--uib-speed) * -0.75);\r\n}\r\n\r\n.dot:nth-child(8) .dot-inner {\r\n  transform: translateX(var(--uib-center));\r\n  animation-delay: calc(var(--uib-speed) * -0.875);\r\n}\r\n\r\n@keyframes oscillate {\r\n  0% {\r\n    transform: translateX(var(--uib-center)) scale(0);\r\n    opacity: 0.25;\r\n  }\r\n\r\n  100% {\r\n    transform: translateX(0) scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes rotate {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
